import { render, staticRenderFns } from "./KanbanNew.vue?vue&type=template&id=298af310&scoped=true"
import script from "./KanbanNew.vue?vue&type=script&scoped=true&lang=js"
export * from "./KanbanNew.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./KanbanNew.vue?vue&type=style&index=0&id=298af310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298af310",
  null
  
)

export default component.exports